import { useCallback, useState } from "react";
import { getWorkOrder } from "../api/WorkOrders";
import { useWorkOrderStore } from "../store/wo-order";
import { ApiResponse } from "../models/api/ApiResponse";

/**
 * Fetches the work order and updates the cache
 * @param woNumber
 * @returns isLoading, trigger
 */

const inFlight: Record<string, Promise<ApiResponse>> = {};

export default function useGetWorkOrder() {
  const [isLoading, setIsLoading] = useState(false);
  const addUpdateWorkOrder = useWorkOrderStore(
    (state) => state.addUpdateWorkOrder
  );

  const trigger = useCallback(
    async (woNumber: string) => {
      setIsLoading(true);
      if (!(woNumber in inFlight))
        //make the api call if it is not already in flight
        inFlight[woNumber] = getWorkOrder({
          woNumber: woNumber,
          resources: true,
          appName: "Mobile",
          translations: true,
          equipmentMaster: true,
          permits: true,
          comment: true,
          events: true,
          inspectionDefinition: false,
          labor: true,
          instruction: true,
        });

      const response = await inFlight[woNumber];
      if (response.status === 200) {
        addUpdateWorkOrder(response.data);
      }
      setIsLoading(false);
      delete inFlight[woNumber]; // Clean up once resolved
      return response;
    },
    [addUpdateWorkOrder]
  );

  return { trigger, isLoading };
}
